export default __webpack_public_path__ + "static/media/member_card_v3_mitra.d7e67a97.png";